/**
 * Список звуков для прогрева.
 *
 * Приходит оверлею один раз при подключении. ЗАЧЕМ ОТДЕЛЬНЫМ
 * СООБЩЕНИЕМ, а не вместе со сценой: звук саундборда — не слой.
 * Его нет на сцене, его не двигают и не выключают, и он должен
 * пережить переключение сцены — как и громкость канала.
 *
 * Разбор здесь, а не в оверлее, по той же причине, что у громкости:
 * панель однажды тоже захочет показывать, что прогрето, и вторая
 * реализация разошлась бы с первой на первой правке.
 */
/** Один звук, который стоит скачать заранее. */
import { decodeMessage } from './message.js';
/** Пусто: звуков в канале нет. Отличается от «сервер ещё не сказал». */
export const NO_SOUNDS = [];
/**
 * Разбирает сообщение `sounds`.
 *
 * Возвращает null для всего остального: вызывающий по этому
 * понимает, что сообщение не про прогрев, и передаёт дальше.
 *
 * ПОРЯДОК СОХРАНЯЕТСЯ. Сервер шлёт список в порядке сетки — под
 * пальцем у стримера лежит то, что он жмёт чаще, и прогревать это
 * стоит первым: бюджет конечен, и что не влезет, вытеснится.
 */
export function parseSounds(raw) {
    const parsed = decodeMessage(raw);
    if (parsed === null)
        return null;
    const message = parsed;
    if (message.t !== 'sounds')
        return null;
    if (!Array.isArray(message.sounds))
        return NO_SOUNDS;
    const out = [];
    for (const entry of message.sounds) {
        const sound = one(entry);
        // Битая запись пропускается молча, а не роняет список: одна
        // испорченная строка в базе не должна лишать прогрева
        // остальные звуки канала
        if (sound !== null)
            out.push(sound);
    }
    return out;
}
function one(raw) {
    if (typeof raw !== 'object' || raw === null)
        return null;
    const entry = raw;
    if (typeof entry.itemId !== 'string' || entry.itemId === '')
        return null;
    // Без адреса качать нечего: такая запись в списке прогрева
    // бесполезна целиком
    if (typeof entry.url !== 'string' || entry.url === '')
        return null;
    return {
        itemId: entry.itemId,
        url: entry.url,
        loudness: finite(entry.loudness),
        durationMs: positive(entry.durationMs),
    };
}
function finite(value) {
    if (typeof value !== 'number' || !Number.isFinite(value))
        return null;
    return value;
}
function positive(value) {
    const parsed = finite(value);
    if (parsed === null || parsed <= 0)
        return null;
    return parsed;
}
//# sourceMappingURL=warm.js.map